/* __next_internal_client_entry_do_not_use__ SDUIGridV2AutoColumnLayoutBase auto */ import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSlateSpacingPixels } from "@faire/retailer-shared/SlateMappings/getSlateSpacingPixels";
import { Column } from "@faire/web--source/slate/Layout";
import { IGridComponent } from "@faire/web-api--source/indigofair/data/IGridComponent";
import { IGridStyle } from "@faire/web-api--source/indigofair/data/IGridStyle";
import { IImageTile } from "@faire/web-api--source/indigofair/data/IImageTile";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import React, { useMemo, useRef, useState } from "react";
import { convertServerResponsivePropertyToClientResponsiveProperty } from "@faire/retailer/components/SDUI/__internal__/Styling/responsiveValues";
import { ActionLoggingEventParams } from "@faire/retailer/components/SDUI/__internal__/types";
import * as v2GridStyles from "@faire/retailer/components/SDUI/ComponentRenderers/Grid/__internal__/GridV2/v2Styles.css";
import { SDUIGridHeaderRow } from "@faire/retailer/components/SDUI/ComponentRenderers/Grid/__internal__/SDUIGridHeaderRow";
import { SDUIGridV2ExpandButton } from "./SDUIGridV2ExpandButton";
import { SDUIGridV2Tile } from "./SDUIGridV2Tile";
import { getGridAutoLayoutRowResponsiveStyleVars } from "./v2AutoLayoutStylingUtils";
export var SDUIGridV2AutoColumnLayoutBase = function(param) {
    var gridComponent = param.gridComponent, loggingData = param.loggingData;
    var containerRef = useRef(null);
    var tileRef = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), isExpanded = _useState[0], setIsExpanded = _useState[1];
    var responsive_truncation_behaviour = gridComponent.responsive_truncation_behaviour, _gridComponent_style = gridComponent.style, style = _gridComponent_style === void 0 ? IGridStyle.build() : _gridComponent_style, title = gridComponent.title, responsive_title = gridComponent.responsive_title, header_background_icon = gridComponent.header_background_icon, responsive_header_background_icon = gridComponent.responsive_header_background_icon, tiles = gridComponent.tiles, _gridComponent_truncation_behaviour = gridComponent.truncation_behaviour, truncation_behaviour = _gridComponent_truncation_behaviour === void 0 ? IGridComponent.ITruncationBehaviour.build() : _gridComponent_truncation_behaviour, log_tile_batch_view = gridComponent.log_tile_batch_view;
    var _style_column_spacing = style.column_spacing, column_spacing = _style_column_spacing === void 0 ? Spacing.SPACING_NONE : _style_column_spacing, _style_row_spacing = style.row_spacing, row_spacing = _style_row_spacing === void 0 ? Spacing.SPACING_NONE : _style_row_spacing;
    var columnSpacingPixels = getSlateSpacingPixels(column_spacing);
    var rowSpacingPixels = getSlateSpacingPixels(row_spacing);
    // TODO (FD-199432): This is an anti-pattern and we generally don't want components reaching into
    // their children's contents to retrieve information. This information should be moved into the proto.
    var imageTileVariant = useMemo(function() {
        var _tiles_find_image_tile_style, _tiles_find_image_tile, _tiles_find;
        var _tiles_find_image_tile_style_variant;
        return (_tiles_find_image_tile_style_variant = (_tiles_find = tiles.find(function(tile) {
            var _tile_image_tile_style, _tile_image_tile;
            return (_tile_image_tile = tile.image_tile) === null || _tile_image_tile === void 0 ? void 0 : (_tile_image_tile_style = _tile_image_tile.style) === null || _tile_image_tile_style === void 0 ? void 0 : _tile_image_tile_style.variant;
        })) === null || _tiles_find === void 0 ? void 0 : (_tiles_find_image_tile = _tiles_find.image_tile) === null || _tiles_find_image_tile === void 0 ? void 0 : (_tiles_find_image_tile_style = _tiles_find_image_tile.style) === null || _tiles_find_image_tile_style === void 0 ? void 0 : _tiles_find_image_tile_style.variant) !== null && _tiles_find_image_tile_style_variant !== void 0 ? _tiles_find_image_tile_style_variant : IImageTile.ImageTileVariant.IMAGE_TILE_VARIANT_UNKNOWN;
    }, [
        tiles
    ]);
    var responsiveTruncationBehaviour = convertServerResponsivePropertyToClientResponsiveProperty(truncation_behaviour, function(truncationBehaviour) {
        return truncationBehaviour;
    }, responsive_truncation_behaviour);
    var _obj;
    return /*#__PURE__*/ _jsxs(Column, {
        className: v2GridStyles.gridWrapper,
        children: [
            /*#__PURE__*/ _jsx(SDUIGridHeaderRow, {
                title: title,
                responsiveTitle: responsive_title,
                backgroundIcon: header_background_icon,
                responsiveBackgroundIcon: responsive_header_background_icon,
                loggingData: loggingData
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames(v2GridStyles.gridTileContainer, v2GridStyles.gridAutoLayout),
                ref: containerRef,
                style: assignInlineVars(_object_spread((_obj = {}, _define_property(_obj, v2GridStyles.varRowGap, "".concat(rowSpacingPixels, "px")), _define_property(_obj, v2GridStyles.varColumnGap, "".concat(columnSpacingPixels, "px")), _obj), getGridAutoLayoutRowResponsiveStyleVars(responsiveTruncationBehaviour, isExpanded, imageTileVariant))),
                children: tiles.map(function(tile, index) {
                    var _tile_logging_data;
                    var _tile_logging_data_instance_identifier;
                    return /*#__PURE__*/ _jsx(SDUIGridV2Tile, {
                        tile: tile,
                        tileRef: index === 0 ? tileRef : undefined,
                        loggingData: loggingData,
                        logTileBatchView: log_tile_batch_view,
                        rowSpacingPixels: rowSpacingPixels
                    }, (_tile_logging_data_instance_identifier = (_tile_logging_data = tile.logging_data) === null || _tile_logging_data === void 0 ? void 0 : _tile_logging_data.instance_identifier) !== null && _tile_logging_data_instance_identifier !== void 0 ? _tile_logging_data_instance_identifier : index);
                })
            }),
            /*#__PURE__*/ _jsx(SDUIGridV2ExpandButton, {
                isExpanded: isExpanded,
                truncationBehaviour: responsiveTruncationBehaviour,
                numTiles: tiles.length,
                containerRef: containerRef,
                tileRef: tileRef,
                columnSpacingPixels: columnSpacingPixels,
                rowSpacingPixels: rowSpacingPixels,
                onClick: function() {
                    return setIsExpanded(true);
                },
                loggingEventParams: ActionLoggingEventParams.build(_object_spread_props(_object_spread({}, loggingData), {
                    action_instance_identifier: "EXPAND"
                }))
            })
        ]
    });
};
